import type { FormEvent, ReactNode } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export function AuthCard(props: {
  title: string;
  subtitle?: string;
  onSubmit: (e: FormEvent) => void;
  children: ReactNode;
}) {
  return (
    <Box sx={{ display: "grid", placeItems: "center", minHeight: "100vh", p: 2 }}>
      <Paper component="form" onSubmit={props.onSubmit} sx={{ p: 4, width: "100%", maxWidth: 420 }}>
        <Stack spacing={2}>
          <Typography variant="h4" component="h1">
            {props.title}
          </Typography>
          {props.subtitle && <Typography color="text.secondary">{props.subtitle}</Typography>}
          {props.children}
        </Stack>
      </Paper>
    </Box>
  );
}
